import { useState, KeyboardEvent } from "react";
import {
  IVerificationInputUpdateReturn,
  IVerificationInputUpdateProps,
} from "../../../Model/UIComponents.model";

export const useVerificationInputUpdate = ({
  inputsRefs,
  length,
  type,
}: IVerificationInputUpdateProps & { type?: "text" | "number" }): IVerificationInputUpdateReturn => {
  const [code, setCode] = useState<string[]>(Array(length).fill(""));
  const [warning, setWarning] = useState<string | undefined>();

  const isValidChar = (char: string) => {
    if (type === "number") return /^[0-9]$/.test(char);
    return /^[a-zA-Z0-9]$/.test(char);
  };

  const onKeyPress = (
  event: KeyboardEvent<HTMLInputElement>,
  index: number
) => {
  const key = event.key;

  if (key === "Backspace") {
    if (!code[index] && index > 0) {
      const prevInput = inputsRefs.current?.[index - 1];
      prevInput?.focus();
      const newCode = [...code];
      newCode[index - 1] = "";
      setCode(newCode);
      setWarning(undefined);
    }
    return;
  }

  // New: detect invalid typed character (for number only)
  if (type === "number" && key.length === 1 && !/^[0-9]$/.test(key)) {
    setWarning("Only numbers are allowed");
  } else {
    setWarning(undefined);
  }
};

 

  const handleChange = (value: string, index: number) => {
    if (value.length > 1) {
      handlePaste(value, index);
    } else {
      handleTyping(value, index);
    }
  };

  const handleTyping = (value: string, index: number) => {
    const char = value.trim();
    if (char && !isValidChar(char)) {
      setWarning(`Only ${type === "number" ? "numbers" : "alphanumeric"} are allowed`);
      return;
    }
    setWarning(undefined);

    const newCode = [...code];
    newCode[index] = char;
    setCode(newCode);

    if (char && index < length - 1) {
      inputsRefs.current?.[index + 1]?.focus();
    }
  };
const handlePaste = (value: string, startIndex: number) => {
  const newCode = [...code];
  let i = startIndex;
  let hasInvalid = false;

  for (const char of value) {
    if (i >= length) break;

    if (!isValidChar(char)) {
      hasInvalid = true;
      i++; 
      continue;
    }

    newCode[i] = char;
    i++;
  }

  setCode(newCode);
  setWarning(hasInvalid ? `Only ${type === "number" ? "numbers" : "alphanumeric"} are allowed` : undefined);

  if (i < length) {
    inputsRefs.current?.[i]?.focus();
  } else {
    inputsRefs.current?.[length - 1]?.blur();
  }
};

const handlePasteEvent = (
  e: React.ClipboardEvent<HTMLInputElement>
) => {
  e.preventDefault();
  const pasted = e.clipboardData.getData("text");

  
  const startIndex = code.findIndex((char) => char.trim() === "");
  handlePaste(pasted, startIndex === -1 ? 0 : startIndex);
};


  return { code, onKeyPress, handleChange, warning ,handlePasteEvent,};
};
